import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=50ec44f0&scoped=true&"
import script from "./icons.ts?vue&type=script&lang=ts&"
export * from "./icons.ts?vue&type=script&lang=ts&"
import style0 from "./icons.vue?vue&type=style&index=0&id=50ec44f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec44f0",
  null
  
)

export default component.exports